module.exports = __webpack_public_path__ + "static/media/menuRole.9e3d573d.svg";